import { render, staticRenderFns } from "./VoiceDatabase.vue?vue&type=template&id=4390eca4&scoped=true&"
import script from "./VoiceDatabase.vue?vue&type=script&lang=js&"
export * from "./VoiceDatabase.vue?vue&type=script&lang=js&"
import style0 from "./VoiceDatabase.vue?vue&type=style&index=0&id=4390eca4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4390eca4",
  null
  
)

export default component.exports